import interrupt from "../interrupt";

export default function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-transition/src/selection/interrupt.js
// module id = 462
// module chunks = 0 1 2 3 4